"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentCircle = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importDefault(require("react"));
const react_circular_progressbar_1 = require("react-circular-progressbar");
const Text_1 = __importDefault(require("../Text"));
const makeMyClasses = size => {
    return {
        root: {
            width: size,
            height: size,
            position: 'relative',
        },
    };
};
function PercentCircle(props) {
    const { percent = 0, label, strokeWidth = 14, size = 48, color = lib_palette_1.default.primary, children, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [size]);
    return (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement(react_circular_progressbar_1.CircularProgressbarWithChildren, { value: percent, strokeWidth: strokeWidth, styles: (0, react_circular_progressbar_1.buildStyles)({
                rotation: 0,
                strokeLinecap: 'round',
                textSize: '24px',
                pathTransitionDuration: 0.5,
                pathColor: color.main,
                trailColor: lib_palette_1.default.LavendarGrey.main,
            }) },
            !!label && (react_1.default.createElement(Text_1.default, { variant: "small", style: { marginTop: -10 } }, label)),
            !!children && children)));
}
exports.PercentCircle = PercentCircle;
exports.default = PercentCircle;
